import type { BannerAdProvider } from "./adPorts.js";

export class NoopBannerProvider implements BannerAdProvider {
  showBanner(): void {}
  removeBanner(): void {}
}
